<script>
export default {
  name: 'TabContainer',

  props: {
    className: {
      type: String,
      default: 'c-tabs__container'
    }
  },

  inject: ['currentTabIndex'],

  render (createElement) {
    const currentTabIndex = this.currentTabIndex()

    return createElement('div', { class: this.className, attrs: this.$attrs }, [
      this.$scopedSlots.default().filter(item => item.isComment === false).map((slot, index) => {
        return this.$cloneNode(slot, { props: { isSelected: index === currentTabIndex } })
      })
    ])
  }
}
</script>
